import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import PageLayout from "src/pages/PageLayout";
import { useParams } from "react-router-dom";
import {
  getApprovedPublicationByUserIdApi,
  getReviewerById,
} from "src/network/api";
import { STATIC } from "src/network/networkConfig";
import LoaderComponent from "../LoaderComponent";

const ReviewerProfile = () => {
  const { id } = useParams();
  const [plainTabs, setPlainTabs] = useState(1);
  const [reviewer, setReviewer] = useState(null);
  const [publications, setPublications] = useState([]);
  const [totalPublication, settotalPublication] = useState("");
  const [totalReviews, settotalReviews] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingPublications, setLoadingPublications] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const toggleNavs = (e, tab) => {
    e.preventDefault();
    setPlainTabs(tab);
  };

  useEffect(() => {
    const fetchReviewer = async () => {
      try {
        setLoading(true);
        const response = await getReviewerById(id);
        setReviewer(response.data.data);
        settotalReviews(response.data.data.total_reviews);
        settotalPublication(response.data.data.total_publications);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchReviewer();
  }, [id]);

  useEffect(() => {
    const fetchPublications = async () => {
      try {
        setLoadingPublications(true);
        const response = await getApprovedPublicationByUserIdApi(id);
        setPublications(response.data.data.publications);
        setLoadingPublications(false);
      } catch (err) {
        console.error("Error fetching publications:", err);
        setLoadingPublications(false);
      }
    };

    if (plainTabs === 2) {
      fetchPublications();
    }
  }, [id, plainTabs]);

  const handleNavigate = () => {
    navigate(`/reviewer-certificate/${id}`);
  };

  return (
    <PageLayout>
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            {loading ? (
              <div className="d-flex justify-content-center">
                <p className="ending">Loading, please wait...</p>
              </div>
            ) : error ? (
              <p className="text-danger text-center">Error: {error}</p>
            ) : (
              <>
                {/* Profile Header */}
                <div className="text-center mb-4">
                  <img
                    src={reviewer.profile_image || STATIC.noImageURL}
                    alt="Reviewer"
                    className="rounded-circle mb-2"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                  <h3 className="font-weight-bold">{reviewer.name}</h3>
                  <p className="text-muted mb-1">
                    {reviewer.designation || "N/A"}
                  </p>
                  <p className="text-primary font-weight-bold">
                    Department: {reviewer.department || "N/A"}
                  </p>
                </div>

                {/* Action Buttons */}
                <div className="text-center mb-3">
                  <button
                    className="btn btn-sm btn-outline-primary mx-2"
                    onClick={handleNavigate}
                  >
                    Certificate
                  </button>
                  <button className="btn btn-sm btn-outline-secondary mx-2">
                    Reviews: {totalReviews}
                  </button>
                  <button className="btn btn-sm btn-primary mx-2">
                    Views: {reviewer.view_count}
                  </button>
                </div>

                {/* Tabs Navigation */}
                <div className="nav-wrapper">
                  <Nav
                    className="nav-fill flex-column flex-md-row"
                    id="tabs-icons-text"
                    pills
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        aria-selected={plainTabs === 1}
                        className={classnames("mb-sm-3 mb-md-0", {
                          active: plainTabs === 1,
                        })}
                        onClick={(e) => toggleNavs(e, 1)}
                        href="#about"
                        role="tab"
                      >
                        About
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        aria-selected={plainTabs === 2}
                        className={classnames("mb-sm-3 mb-md-0", {
                          active: plainTabs === 2,
                        })}
                        onClick={(e) => toggleNavs(e, 2)}
                        href="#publications"
                        role="tab"
                      >
                        Publications ({totalPublication})
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>

                {/* Tab Content */}
                <Card className="border-none">
                  <CardBody>
                    <TabContent activeTab={`plainTabs${plainTabs}`}>
                      {/* About Section */}
                      <TabPane tabId="plainTabs1">
                        <table className="table table-bordered text-left">
                          <tbody>
                            <tr>
                              <th>Name</th>
                              <td>{reviewer.name || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Designation</th>
                              <td>{reviewer.designation || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Department/College</th>
                              <td>{reviewer.department || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Research Area</th>
                              <td>{reviewer.research_area || "N/A"}</td>
                            </tr>
                            {/* <tr>
                              <th>Email</th>
                              <td>{reviewer.email || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Contact</th>
                              <td>{reviewer.contact || "N/A"}</td>
                            </tr> */}
                            <tr>
                              <th>Country</th>
                              <td>{reviewer.country_name || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>State</th>
                              <td>{reviewer.state_name || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>University/Organization</th>
                              <td>{reviewer.university_name || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Qualification</th>
                              <td>{reviewer.maximum_qualification || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>About</th>
                              <td>{reviewer.about || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>Profile Link</th>
                              <td>
                                {reviewer.profile_link
                                  ? reviewer?.profile_link
                                      .split(",")
                                      .map((link, index) => {
                                        return (
                                          <a
                                            className="badge badge-info mr-1"
                                            href={link}
                                            target="_blank"
                                          >
                                            View Profile{" "}
                                            {index > 0 && (
                                              <span>{index + 1}</span>
                                            )}{" "}
                                            <i className="fa fa-external-link"></i>
                                          </a>
                                        );
                                      })
                                  : "N/A"}
                              </td>
                            </tr>

                            <tr>
                              <th>Status</th>
                              <td>
                                <span className="badge badge-success">
                                  Verified
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </TabPane>
                      <TabPane tabId="plainTabs2">
                        {loadingPublications ? (
                          <div className="d-flex justify-content-center">
                            <p className="ending">Loading, please wait...</p>
                          </div>
                        ) : publications.length > 0 ? (
                          publications.map((publication, index) => (
                            <div
                              key={index}
                              className="tab-pane fade show active"
                            >
                              <table className="table table-bordered shadow text-left">
                                <tbody>
                                  <tr>
                                    <th>Title</th>
                                    <td>{publication.paper_title || "N/A"}</td>
                                  </tr>
                                  <tr>
                                    <th>Author(s)</th>
                                    <td>{publication.authors || "N/A"}</td>
                                  </tr>

                                  <tr>
                                    <th>Publication year</th>
                                    <td>
                                      {publication.publication_year || "N/A"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Publication date</th>
                                    <td>
                                      {publication.publication_date || "N/A"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Paper type</th>
                                    <td>{publication.paper_type || "N/A"}</td>
                                  </tr>
                                  <tr>
                                    <th>ISSN</th>
                                    <td>{publication.issn || "N/A"}</td>
                                  </tr>

                                  <tr>
                                    <th>Approval status</th>
                                    <td>
                                      <span className="badge badge-success">
                                        {publication.approval_status || "N/A"}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Volume</th>
                                    <td>{publication.volume || "N/A"}</td>
                                  </tr>
                                  <tr>
                                    <th>Description</th>
                                    <td>{publication.description || "N/A"}</td>
                                  </tr>
                                  <tr>
                                    <th>Issue</th>
                                    <td>{publication.issue || "N/A"}</td>
                                  </tr>

                                  <tr>
                                    <th>Indexing</th>
                                    <td>
                                      {publication.indexing_with || "N/A"}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th>Actions</th>
                                    <td>
                                      <a
                                        href={publication.live_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <button className="btn btn-sm btn-primary mr-3">
                                          View Paper
                                        </button>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <hr />
                            </div>
                          ))
                        ) : (
                          <div className="d-flex justify-content-center">
                            <p className="ending">No publications found.</p>
                          </div>
                        )}
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              </>
            )}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default ReviewerProfile;
